import React from 'react';
import { Shield, FlaskConical, Award, Package, Building2 } from 'lucide-react';
import { useRegional } from '../../context/RegionalContext';

const AnnouncementBar = () => {
  const { region } = useRegional();
  
  // B2B compliant announcements - no promotional/consumer language
  const baseAnnouncements = [
    { text: 'B2B Institutional Supply', icon: Building2 },
    { text: 'Tracked Commercial Shipping', icon: Package },
    { text: 'Direct B2B Logistics', icon: FlaskConical },
    { text: 'Institutional Accounts Only', icon: Shield },
  ];
  
  // Only show "Made in USA" for US region
  const announcements = region?.code === 'US' 
    ? [
        baseAnnouncements[0],
        baseAnnouncements[1],
        { text: 'MADE in USA', icon: Award },
        baseAnnouncements[2],
        baseAnnouncements[3],
      ]
    : baseAnnouncements;
  
  // Duplicate items 4x for truly seamless infinite loop
  const items = [...announcements, ...announcements, ...announcements, ...announcements];

  return (
    <div 
      className="bg-slate-900 text-white py-2.5 relative z-50" 
      style={{ 
        overflow: 'hidden', 
        width: '100%',
        contain: 'paint'
      }} 
      data-testid="announcement-bar"
    >
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .announcement-track {
          display: flex;
          width: fit-content;
          animation: marquee-scroll 40s linear infinite;
          will-change: transform;
        }
        .announcement-track:hover {
          animation-play-state: paused;
        }
        @media (max-width: 1024px) {
          .announcement-track {
            animation-duration: 20s;
          }
        }
      `}</style>
      
      <div className="announcement-track">
        {items.map((item, index) => (
          <div 
            key={index} 
            className="flex items-center gap-2 mx-6 sm:mx-10 text-xs sm:text-sm font-medium tracking-wide flex-shrink-0"
          >
            <item.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-cyan-400 flex-shrink-0" />
            <span className="whitespace-nowrap">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
